import styled from 'styled-components'
import PropTypes from 'prop-types'

import colors from 'components/utils/colors'

const StyledSpinner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .thecube {
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    margin: 0 auto;
    position: relative;
    transform: rotateZ(45deg) scale(0.68);

    .cube {
      position: relative;
      transform: rotateZ(45deg);
    }

    .cube {
      float: left;
      width: 50%;
      height: 50%;
      position: relative;
      transform: scale(1.1);
    }

    .cube:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: ${colors.bgPrimaryHoverButton};
      animation: foldthecube 2.4s infinite linear both;
      transform-origin: 100% 100%;
    }

    .c2 {
      transform: scale(1.1) rotateZ(90deg);
    }

    .c3 {
      transform: scale(1.1) rotateZ(180deg);
    }

    .c4 {
      transform: scale(1.1) rotateZ(270deg);
    }

    .c2:before {
      animation-delay: 0.3s;
    }

    .c3:before {
      animation-delay: 0.6s;
    }

    .c4:before {
      animation-delay: 0.9s;
    }

    @keyframes foldthecube {
      0%, 10% {
        transform: perspective(140px) rotateX(-180deg);
        opacity: 0;
      }

      25%,
      75% {
        transform: perspective(140px) rotateX(0deg);
        opacity: 1;
      }

      90%,
      100% {
        transform: perspective(140px) rotateY(180deg);
        opacity: 0;
      }
    }
  }
`
const StyledSpan = styled.span`
  margin-left: 4px;
  font-size: ${props => props.textSize || '16px'};
  color: ${colors.contentSecondaryActive};
`

const Spinner = ({ text, size = 16, textSize, className }) => {
  return (
    <StyledSpinner size={size} className={className}>
      <div className='thecube'>
        <div className='cube c1' />
        <div className='cube c2' />
        <div className='cube c4' />
        <div className='cube c3' />
      </div>
      {text && <StyledSpan textSize={textSize}>{text}</StyledSpan>}
    </StyledSpinner>
  )
}

Spinner.propTypes = {
  text: PropTypes.string,
  size: PropTypes.number,
  textSize: PropTypes.string,
}

export default Spinner
